<div class="script-page">
    <app-data-table addButtonText="{{ 'ScriptsPage.AddButton' | translate }}" title="{{ 'ScriptsPage.Title' | translate }}" filterPlaceholder="{{ 'ScriptsPage.FilterPlaceholder' | translate }}" 
    (openModal)="openScript($event)" (deleteRow)="deleteScript($event)" [displayedColumnsName]="displayedColumnsName"
        [displayedColumns]="displayedColumns" [data]="allScripts">
    </app-data-table>
  </div>

  <!-- (openModal)="openRole($event)" 
(deleteRow)="deleteRole($event)"
-->